export default "__VITE_ASSET__Cex1AkWU__"